import { createFileRoute } from '@tanstack/react-router'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { getContentPage } from '~/lib/content/content'
import { MarkdownPage } from '~/components/sections/MarkdownPage'

export const Route = createFileRoute('/terms-of-service')({
  loader: () => getContentPage({ data: 'terms-of-service' }),
  headers: () => cacheHeaders.content,
  head: () =>
    pageMeta({
      title: 'Terms of Service',
      description:
        'Terms of Service for electronic communications (email and SMS) from Direct Action Everywhere.',
      ogDescription: 'Terms of Service for electronic communications.',
    }),
  component: Page,
})

function Page() {
  return <MarkdownPage html={Route.useLoaderData()} />
}
